import { useState } from 'react';

const KEY = 'kit.sidebar';

/** Whether the desktop sidebar is expanded, remembered on this device. */
export function useSidebarOpen(): [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState(() => localStorage.getItem(KEY) !== 'collapsed');
  function change(next: boolean) {
    setOpen(next);
    localStorage.setItem(KEY, next ? 'expanded' : 'collapsed');
  }
  return [open, change];
}
